import { Button, ButtonProps, Field, InfoLabel, Slot } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, useRef } from 'react';
import { useCommonStyles } from '../../common/hooks';
import { FlexBox } from './flex-box';
import './UploadButton.scss';

interface UploadButtonProps {
  buttonProps: ButtonProps;
  onUpload: (event: FileList) => void;
  acceptFiles?: string;
  validationMessage?: Slot<'div'>;
  infoLabel?: string;
  restoreButtonProps?: ButtonProps;
}

const UploadButtonImpl: React.FC<PropsWithChildren<UploadButtonProps>> = (props) => {
  const {
    buttonProps,
    onUpload,
    acceptFiles,
    validationMessage,
    infoLabel,
    children,
    restoreButtonProps,
  } = props;

  const commonStyles = useCommonStyles();
  const uploaderRef = useRef<HTMLInputElement>(null);

  return (
    <FlexBox
      direction='column'
      className='upload-button'
    >
      {children}
      <Field
        validationMessage={validationMessage}
        validationMessageIcon={null}
      >
        <FlexBox className='upload-button__uploader'>
          {
            infoLabel ? (
              <InfoLabel
                info={{
                  children: infoLabel,
                  className: commonStyles.tooltip,
                }}
                className='upload-button__info-label'
              >
                <Button
                  {...buttonProps}
                  onClick={() => uploaderRef.current?.click()}
                />
              </InfoLabel>
            ) : (
              <Button
                {...buttonProps}
                onClick={() => uploaderRef.current?.click()}
              />
            )
          }
          {
            !!restoreButtonProps &&
            <Button
              {...restoreButtonProps}
              children={restoreButtonProps?.children || 'Restore'}
            />
          }
        </FlexBox>
      </Field>
      <input
        type='file'
        hidden
        ref={uploaderRef}
        onChange={events => events.target.files && onUpload(events.target.files)}
        accept={acceptFiles}
      />
    </FlexBox>
  );
};

export const UploadButton = observer(UploadButtonImpl);
